"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebBundlr = exports.default = void 0;
var bundlr_1 = require("./bundlr");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(bundlr_1).default; } });
var bundlr_2 = require("./bundlr");
Object.defineProperty(exports, "WebBundlr", { enumerable: true, get: function () { return __importDefault(bundlr_2).default; } });
//# sourceMappingURL=index.js.map